/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Surveillance type
 */
export type ReportBodyDtoSurveillanceType =
  (typeof ReportBodyDtoSurveillanceType)[keyof typeof ReportBodyDtoSurveillanceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportBodyDtoSurveillanceType = {
  active: 'active',
  passive: 'passive',
  other: 'other',
} as const;
